import { FC, PropsWithChildren } from "react";
import { Grid, useResponsiveDisplayMode } from "capitalrx-components-2.0/lib/layout";
import { ContentContainer, ThemedGradient } from "@/premium/themedComponents";
import "./PageLayout.scss";

export const PageLayout: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const displayMode = useResponsiveDisplayMode();
  const containerClassName = displayMode === "desktop" ? "page-layout-grid" : "page-layout-grid page-layout-grid-mobile";

  return (
    <ContentContainer>
      <ThemedGradient />
      <Grid className={containerClassName}>
        {displayMode === "desktop" && <Grid.Span columns={1} />}
        <Grid.Span columns={displayMode === "desktop" ? 10 : 12}>
          <>{children}</>
        </Grid.Span>
        {displayMode === "desktop" && <Grid.Span columns={1} />}
      </Grid>
    </ContentContainer>
  );
};
